document.addEventListener("DOMContentLoaded", () => {

  const swiperSTimeline = document.querySelector('.cv-tm--swiper');

  if (swiperSTimeline) {
    function initTimelineSwiper() {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);

          new Swiper(entry.target, {
            loop: true,
            mousewheel: false,
            effect: 'slide',
            slidesPerView: "auto",
            spaceBetween: 6
          });
        });
      }, { rootMargin: '300px 0px' });

      observer.observe(swiperSTimeline);
    }

    if (typeof Swiper !== 'undefined') {
      initTimelineSwiper();
    } else {
      document.addEventListener('swiper:loaded', initTimelineSwiper, { once: true });
    }
  }

  // timeline JS
  const items = document.querySelectorAll('.timeline-item');
  let activeIndex = 0;

  function toggleAccordion(index, scroll) {
    items.forEach((item, i) => {
      const content = item.querySelector('.timeline-content');
      const header = item.querySelector('.timeline-header');

      if (i === index) {
        content.classList.add('open');
        header.classList.add('active');

        if (scroll === true) {
          item.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

      } else {
        content.classList.remove('open');
        header.classList.remove('active');
      }
    });
    activeIndex = index;
  }

  document.querySelectorAll('.timeline-header').forEach((header, index) => {
    header.addEventListener('click', () => toggleAccordion(index, false));
  });

  document.getElementById('prev').addEventListener('click', () => {
    activeIndex = (activeIndex - 1 + items.length) % items.length;
    toggleAccordion(activeIndex, false);
  });

  document.getElementById('next').addEventListener('click', () => {
    activeIndex = (activeIndex + 1) % items.length;
    toggleAccordion(activeIndex, false);
  });

  toggleAccordion(0, false);

});
